// Configure HTMX to include CSRF token in requests
function getCsrfToken() {
  // Get CSRF token from cookie or meta tag
  const tokenElement = document.querySelector('[name=csrfmiddlewaretoken]');
  if (tokenElement) {
    return tokenElement.value;
  }

  // Fallback to cookie
  const name = 'csrftoken';
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Add CSRF token to all HTMX requests
document.body.addEventListener('htmx:configRequest', (event) => {
  event.detail.headers['X-CSRFToken'] = getCsrfToken();
});
